export default {"src":"/_next/static/media/flag-en.2481c9e6.svg","height":12,"width":18,"blurWidth":0,"blurHeight":0};